import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { auditStatusConfigForAuditMaster } from "../../../config/AuditStatusConfig";
import { Icons } from "../../../config/MuiIcons.config";
import { AppTheme } from "../../../theme/App.theme";
const { pendingAtAuditor, auditedByAuditor, auditedByAuditee, closePending, newAudits, closed } =
  auditStatusConfigForAuditMaster;
  
// Main data table for audit master
export const auditMasterDataTableColumns = [
  {
    label: "Action",
    isSort: false,
    id: "ActionToEditAndDelete",
    columnWidth: "100px",
    isIcon: true,
    cellAlign: "center",
    headerAlign: "center",
  },
  {
    label: "Audit Type",
    excelName: "Audit Type",
    isSort: false,
    id: "auditTypeName",
    columnWidth: '100px',
    isIcon: false,
  },
  {
    label: "Department",
    excelName: "Audit Type",
    isSort: false,
    id: "departmentName",
    isIcon: false,
  },
  {
    label: "Area",
    excelName: "Area",
    isSort: false,
    id: "areaName",
    isIcon: false,
  },
  {
    label: "Status",
    excelName: "Status",
    isSort: false,
    id: "status",
    isIcon: false,
  },
  {
    label: "User Role",
    excelName: "User Role",
    isSort: false,
    id: "userRole",
    columnWidth: '100px',
    isIcon: false,
  },
  {
    label: "Start Date",
    excelName: "Start Date",
    isSort: true,
    id: "startDate",
    columnWidth: '125px',
    isDate: true,
    isIcon: false,
  },
  {
    label: "End Date",
    excelName: "End Date",
    isSort: true,
    id: "endDate",
    columnWidth: '120px',
    isDate: true,
    isIcon: false,
  },
  {
    label: "Day(s) Left",
    excelName: "Day(s) Left",
    isSort: true,
    id: "differenceInDays",
    isIcon: false,
    columnWidth: '135px',
    cellAlign: "center",
    headerAlign: "center",
  },
];

export const dataTableColumnsForUpdateActivityStatus = [
  {
    label: "Activity Description",
    isSort: false,
    id: "name",
    isIcon: false,
    columnWidth: "200px"
  },
  {
    label: "Progress Status",
    isSort: false,
    id: "complianceStatus",
    isIcon: false,
    columnWidth: "250px"
  },
  {
    label: "Observation By Auditor",
    isSort: false,
    id: "auditorObservation",
    isIcon: false,
    columnWidth: "300px"
  },
  {
    label: "CAPA",
    isSort: false,
    id: "capa",
    isIcon: false,
    columnWidth: "300px"
  },
  {
    label: "Audit Point Status",
    isSort: false,
    id: "verificationStatus",
    isIcon: false,
    columnWidth: "200px"
  },
  {
    label: "Remarks By Auditor",
    isSort: false,
    id: "remark",
    isIcon: false,
    columnWidth: "300px"
  },
  {
    label: "Target Date",
    isSort: false,
    id: "targetDate",
    isIcon: false,
    columnWidth: "200px"
  },
]

// Config for compliance status
export const complianceStatusConfig = [
  {
    label: "Not Confirmed",
    value: "Not Confirmed",
  },
  {
    label: "Confirmed",
    value: "Confirmed",
  },
  {
    label: "Area for Improvement",
    value: "Area for Improvement",
  },
  {
    label: "Not Applicable",
    value: "Not Applicable",
  },
  {
    label: "Not Audited",
    value: "Not Audited",
  },
];

export const verificationStatusConfig = [
  {
    label: "Open",
    value: "Open",
  },
  {
    label: "Closed",
    value: "Closed",
  },
  {
    label: "Not Applicable",
    value: "Not Applicable",
    isDisabled: true,
  },
  {
    label: "Confirmed",
    value: "Confirmed",
    isDisabled: true,
  },
];

export const isVarificationStatusWillBeOpened = [
  "Area for Improvement",
  "Not Confirmed"
]

export const isVarificationStatusWillBeNA = [
  "Not Applicable",
  "Not Audited",
  "Not Confirmed"
];

export const capaShouldBeEmpty = ["Not Applicable", "Not Audited", "Confirmed"];

export const varificationStatus_should_be_disable = ["Not Applicable", "Not Audited", "Confirmed"]

// Audit Status Config
export const auditStatusConfig = [
  {
    label: "All",
    value: "All"
  },
  {
    label: "New",
    value: "New"
  },
  {
    label: "Pending At Auditor",
    value: "Pending At Auditor"
  },
  {
    label: "Audited",
    value: "Audited"
  },
  {
    label: "Pending At Auditee",
    value: "Pending At Auditee"
  },
  {
    label: "Submitted By Auditee",
    value: "Submitted By Auditee"
  },
  {
    label: "Closed",
    value: "Closed"
  },
]

export const dateFrequencyConfig = [
  {
    label: "Week",
    value: "week",
  },
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Half Year",
    value: "half-year",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "Custom",
    value: "custom",
  },
]

// Audit ranges to show pill color accordingly
export const alertRangeForAudit = Array.from({ length: 4 }, (_, i) => i);
export const warningRangeForAudit = Array.from({ length: 7 }, (_, i) => i + 4);
// export const greenRangeForAudit = Array.from({ length: 90 }, (_, i) => i + 11);


// Function to check if the audit submission status is valid based on the role and activity list
// This function checks the compliance status and verification status of activities
// based on the user's role (Auditor or Auditee) and returns an object indicating whether to show a modal and the new status.
export const checkAuditSubmissionStatus = (activityList, role) => {
  if (!Array.isArray(activityList) || !role) return { showModal: false, newStatus: null };

  if (role === "Auditor") {
    const allowedStatuses = [
      "Confirmed",
      "Not Confirmed",
      "Not Applicable",
      "Area for Improvement",
      "Not Audited",
    ];

    const isValid = activityList.every((activity) => {
      const isAllowedStatus = allowedStatuses.includes(activity.complianceStatus);
      const needsObservation =
        activity.complianceStatus === "Area for Improvement" ||
        activity.complianceStatus === "Not Confirmed";

      return (
        isAllowedStatus &&
        (!needsObservation ||
          (activity.auditorObservation?.trim() !== "" &&
           activity.targetDate?.trim() !== ""))
      );
    });

    return {
      showModal: isValid,
      newStatus: isValid ? auditedByAuditor : pendingAtAuditor,
    };
  }

  if (role === "Auditee") {
    const allowedStatuses = ["Closed", "Not Applicable", "Confirmed"];

    const isValid = activityList.every((activity) => {
      const isAllowedStatus = allowedStatuses.includes(activity.verificationStatus);
      const needsCapa = activity.verificationStatus === "Closed";

      return (
        isAllowedStatus &&
        (!needsCapa || activity.capa?.trim() !== "")
      );
    });

    return {
      showModal: isValid,
      newStatus: isValid ? closePending : auditedByAuditee,
    };
  }

  return { showModal: false, newStatus: null };
};


// Function to return chip color based on the audit status
export const getStatusChipDetails = (AuditStatus) => {
  if (AuditStatus === newAudits) {
    return {
      pillColor: "#E0F7FA",
      textColor: "#006064",
      status: newAudits,
    };
  } else if (AuditStatus === pendingAtAuditor) {
    return {
      pillColor: "#FFF3E0",
      textColor: "#E65100",
      status: pendingAtAuditor,
    };
  } else if (AuditStatus === auditedByAuditor) {
    return {
      pillColor: "#E8F5E9",
      textColor: "#2E7D32",
      status: auditedByAuditor,
    };
  } else if (AuditStatus === auditedByAuditee) {
    return {
      pillColor: "#FFFDE7",
      textColor: "#F9A825",
      status: auditedByAuditee,
    };
  } else if (AuditStatus === closePending) {
    return {
      pillColor: "#E3E8F6",
      textColor: "#2749b0",
      status: closePending,
    };
  } else if (AuditStatus === closed) {
    return {
      pillColor: "#FFEBEE",
      textColor: "#C62828",
      status: closed,
    };
  } else {
    return {
      pillColor: "#DAE7F1",
      textColor: "#3476B9",
      status: AuditStatus,
    };
  }
};

export const AuditStatusPill = ({ data }) => {
  return (
    <Chip
      sx={{
        borderRadius: "3px",
        border: `1px solid ${getStatusChipDetails(data).textColor}`,
        background: getStatusChipDetails(data).pillColor,
        color: getStatusChipDetails(data).textColor,
        height: "20px",
      }}
      size="small"
      label={
        <Tooltip title={getStatusChipDetails(data).status} placement="top">
          <span style={{ fontSize: "12px" }}>
            {getStatusChipDetails(data).status}
          </span>
        </Tooltip>
      }
    />
  );
}

// Component to show internal audit info
export const InternalAuditInfo = () => {
  const AuditInfo = (
    <div>
      <p>
        <strong>Internal Audit Flow (Quick Guide)</strong>
      </p>
      <ol style={{ paddingLeft: "16px", margin: 0 }}>
        <li>
          <strong>Admin/SuperAdmin</strong> creates the audit → Status:{" "}
          <em>
            <strong>New</strong>
          </em>
          <br />
          All fields are mandatory. Auditor & Auditee can be changed until the
          auditor takes action.
        </li>
        <li>
          <strong>Auditor</strong> fills progress status & target date → Status:{" "}
          <em>
            <strong>Pending at Auditor</strong>
          </em>
          <br />
          Required only for NC activities (Area for Improvement or Not
          Confirmed).
          <br />
          Once all are filled, status changes to{" "}
          <em>
            <strong>Pending at Auditee</strong>
          </em>
          .
        </li>
        <li>
          <strong>Auditee</strong> updates CAPA, Verification Status, and
          uploads files(Not Compulsory)
          <br />
          Only applicable for NC activities.
          <br />
          Audit status changes to{" "}
          <em>
            <strong>Submitted by Auditee</strong>
          </em>{" "}
          once all NCs are Closed and have CAPA.
        </li>
        <li>
          <strong>Auditor</strong> adds final remarks (optional) and closes the
          audit → Status:{" "}
          <em>
            <strong>Closed</strong>
          </em>
          <br />
          No further edits allowed. Audit can be printed.
        </li>
      </ol>
    </div>
  );

  return (
      <React.Fragment>
        <Tooltip title={AuditInfo} placement="bottom" arrow>
          <Icons.InfoIcon
            fontSize="small"
            sx={{
              color: AppTheme.PRIMARY_COLOR,
            }}
          />
        </Tooltip>
      </React.Fragment>
    );
}  


// Function to change the date settings of Audit Management Dashboard
export const handleDateSettings = (FROMDATE, TODATE, FREQUENCY) => {
  const dateSettings = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_DATE_SETTINGS)
  );

  const updatedDateSettings = {
    ...dateSettings,
    fromDate: FROMDATE,
    toDate: TODATE,
    frequency: FREQUENCY,
  };
  
  localStorage.setItem(
    process.env.REACT_APP_DEV_DATE_SETTINGS,
    JSON.stringify(updatedDateSettings)
  );
}